import React, {
    Component,
    useState
} from 'react'

import { makeStyles } from '@material-ui/core/styles';
import Switch from '@material-ui/core/Switch';

const useStyles = makeStyles({
    switchBase: {
        color: '#cfcfcf',
        '&$checked': {
            color: '#82b1ff',
        },
        '&$checked + $track': {
            backgroundColor: '#82b1ff',
        },
    },
    checked: {},
    track: {},
});

const XSwitch = (props) => {
    const classes = useStyles();
    return (
        <div className="xswitch" style={props.style}>
            <div className="xswitch-label">
                {props.label}
            </div>
            <div className="xswitch-value">
                <Switch
                    classes={classes}
                    label={props.label}
                    name={props.name}
                    defaultChecked={props.value}
                    disabled={props.disabled}
                    onChange={e=>{
                        props.handleChange(!props.value);
                    }}
                />
            </div>
        </div>
    )
}

export default XSwitch;